import React, { useEffect, useState } from 'react'
import { PlusOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import './ShipmentListMenu.css'
import { Button, Menu, Modal } from 'antd';
import { useNavigate, useParams } from "react-router-dom";
import { clearShippingBatchItems, clearShippingDocumentDetails, doGetBatchItems, doGetShippingDocumentDetailsById } from 'store/slices/shippingDocumentSlice';
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks';
import { DeleteIcon } from 'icons/Icons';
import { deleteScan, getAttachedRFIDReader, getBatchesOfShipment, newScan } from 'api/shipping.api';
import { DownIcon } from 'icons/svg';
import { notificationController } from 'controllers/notificationController';
import RfidAttachModel from './RfidAttachModel';
import RfidCorruptedModel from './RfidCorruptedModel';
import DonateClothes from "../../../icons/animations/donate-clothes.json"
import { lottieOptions } from 'utils/utils';
import Lottie from 'react-lottie';
import ShipmentProgressBar from './ShipmentProgressBar/ShipmentProgressBar';
import { IShipmentRoutes, TRoutes } from 'domain/Shipment';

const { confirm } = Modal;

export default function ShipmentListMenu() {

const shipmentList: IShipmentRoutes[] = [
  {
    name: 'All Scans',
    route: 'all-scans',
    qty: '0'
  },
  {
    name: 'Barcodes',
    route: 'barcode',
    qty: '0'
  },
  {
    name: 'RFID Scan',
    route: 'rfid',
    qty: '0',
    children: []
  },
  {
    name: 'Bulk Orders',
    route: 'bulk-orders',
    qty: '0'
  },
  {
    name: 'Missing Items',
    route: 'missing-items',
    qty: 0,
  },
  {
    name: 'COG',
    route: 'wash',
    qty: '0'
  },
]
  const [loading, setLoading] = useState<boolean>(false);
  const [newScanLoading, setNewScanLoading] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [rfIdAttachRequired, setRFIDAttachRequired] = useState<any>(false);
  const [rfidAttachModelVisible, setRfidAttachModelVisible] = useState<any>(false);
  const [rfidCorruptedModel, setRfidCorruptedModel] = useState<boolean>(false);
  const [isException, setIsException] = useState<boolean>(false);
  const [rfidCorruptedData, setRfidCorruptedData] = useState<any>();
  const [shipmentListData, setShipmentListData] = useState<IShipmentRoutes[]>(shipmentList);
  const [selectedKey, setSelectedKey] = useState<string>('');
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const {
    shipping_document_details,
    rfid_Scanner_connected
  } = useAppSelector((state) => state.shippingDocument);
  const { pathname } = window.location;
  const path = pathname.split('/').pop()
  const isRfidPage = path === 'rfid';

  const filteredShipmentList = shipmentListData?.filter((item: any) => {
    return (
      (shipping_document_details?.shipment_type === 1 && item.route !== 'bulk-orders') ||
      (shipping_document_details?.shipment_type === 2 && item.route !== 'wash')
    );
  });

  const getNewScan = () => {
    setNewScanLoading(true);
    newScan(id, {}).then(
      (data: any) => {
        loadBatches(false, true);
        dispatch(doGetShippingDocumentDetailsById(id));
        setNewScanLoading(false);
        if (data?.data || data?.unknown_tags) {
          setRfidCorruptedModel(true);
          if (data?.data || data?.unknown_tags) setRfidCorruptedData(data)
        }
      },
      (err) => {
        dispatch(doGetShippingDocumentDetailsById(id));
        loadBatches(false, true);
        setNewScanLoading(false);
        notificationController.error({ message: err.message });
      }
    );
  };
  const loadBatches = (first: boolean = false, last: boolean = false) => {
    setLoading(true);
    getBatchesOfShipment(id)
      .then((data) => {
        const children: any = []
        data.map((item) => {
          children.push({
            name: 'RFID' + item.batch_number,
            route: item.id + '/',
            id: item.id,
            qty: item.num_of_items,
            exception: +item.number_of_batch_exceptions,
          })
        })
        const exception = children.some((scan: any) => scan.exception > 0)
        setIsException(exception)
      
        setShipmentListData((prev) => {
          const newShipmentList = [...prev];
          newShipmentList[2].children = children;
          newShipmentList[2].qty = children.length;
          return newShipmentList;
        });

        setLoading(false);
        if (first && isRfidPage) {
          setSelectedKey(children[0]?.route)
          dispatch(doGetBatchItems({ id: data[0].id, batchNumber: 'RFID' + data[0].batch_number }));
        }
        if (last && isRfidPage) {
          setSelectedKey(children[children.length - 1].route)
          dispatch(doGetBatchItems({
            id: data[data.length - 1].id,
            batchNumber: 'RFID' + data[data.length - 1].batch_number
          }));
        }
      })
      .catch((err) => { });
  };

  const checkAttachedRFIDReader = () => {
    getAttachedRFIDReader()
      .then((data) => {
        if (data.length == 0) {
          setRFIDAttachRequired(true);
        } else {
          setRFIDAttachRequired(false);
        }
      })
      .catch((err) => { });
  };

  const updateShipmentMenuQuantity = ({ payload }: any) => {
    if(!payload) return
    const menuKeys: { [key in TRoutes]: string } = {
      "all-scans": "",
      barcode: "number_of_barcode_items",
      rfid: "",
      "bulk-orders": "",
      "missing-items": "number_of_missing_items",
      wash: "number_of_wash_items",
    };

    const updatedShipmentList = shipmentList.map((shipment) => {
      // updating the shipmentList according to the keys
      const keyOfApi = menuKeys[shipment.route];
      if (!keyOfApi) return shipment;

      return { ...shipment, qty: payload[keyOfApi] };
    });

    // set All scans value
    updatedShipmentList[0].qty =
      +payload?.number_of_rfid_items + +payload?.number_of_barcode_items;

    setShipmentListData(updatedShipmentList)
  };


  useEffect(() => {
    dispatch(doGetShippingDocumentDetailsById(id))
      .then(updateShipmentMenuQuantity)
    loadBatches(true);
    checkAttachedRFIDReader()

    return () => {
      dispatch(clearShippingDocumentDetails())
      setShipmentListData(shipmentList)
    };
  }, [])

  useEffect(() => {
    checkAttachedRFIDReader()
  }, [rfid_Scanner_connected])

  const handleMenuItemSelect = (selectedValue: { key: string }) => {
    if (selectedValue.key) {
      if (selectedValue.key.includes('/')) {
        setSelectedKey(selectedValue.key)
        const batchId = selectedValue.key.split('/')[0];
        navigate(`shipment-document/details/${id}/rfid`);
        const selectedBatch :any = shipmentListData[2]?.children?.find((item: any) => item.id == batchId);
        dispatch(doGetBatchItems({ id: batchId, batchNumber: selectedBatch.name }));
      } else {
        dispatch(clearShippingBatchItems())
        setSelectedKey('');
        navigate(`shipment-document/details/${id}/${selectedValue.key}`);
      }
    }
  };
  const deleteBatch = (id: any) => {
    confirm({
      title: "Are you sure want to delete the Batch?",
      icon: <ExclamationCircleOutlined />,
      content: "",
      onOk() {
        setLoading(true);
        deleteScan(id).then(
          () => {
            setLoading(false);
            dispatch(clearShippingBatchItems())
            setSelectedKey('')
            notificationController.success({
              message: "Batch deleted successfully.",
            });
            loadBatches();
          },
          (err) => {
            setLoading(false);
            notificationController.error({ message: err.message });
          }
        );
      },
      onCancel() { },
    });
  };
  return (
    <div className='shipment-list'>
      {newScanLoading && (
        <div className="scan-loading">
          <Lottie options={lottieOptions(DonateClothes)} width={500} />
        </div>
      )}
      {loading && (
        <div className="full-loading">
          <span>Loading…</span>
        </div>
      )}

      <ShipmentProgressBar
        itemScanned={shipping_document_details?.total_scanned_items}
        missingItems={shipping_document_details?.number_of_missing_items}
      />

      <div className="shipment-wrapper">
        <Menu
          theme="light"
          mode="inline"
          style={{ background: '#E0E0E0', color: '#000000' }}
          defaultSelectedKeys={[path || 'barcode']}
          selectedKeys={isRfidPage ? [selectedKey] : [path || 'barcode']}
          onSelect={handleMenuItemSelect}
        >
          {filteredShipmentList?.map((nav: any, index: number) => (
            nav?.children?.length > 0 ? (
              <>
                <Menu.SubMenu
                  key={index}
                  theme='light'
                  style={{ background: 'none' }}
                  title={
                    <div className='justify-between'>
                      <span>
                        <DownIcon />
                        <span>
                          {nav.name}
                        </span>
                      </span>
                      <div className={`${isException ? 'rfid-detail' : 'rfid-detail-end'}`}>
                        {isException && <div className='exception-show' />}
                        <p>({nav.qty})</p>
                      </div>
                    </div>
                  }
                  popupClassName="d-none"
                >
                  {nav.children.map((childNav: any) => {
                    return (
                      <Menu.Item className={`submenu-items ${selectedKey?.includes(childNav.route) && 'selectd-scan'}`}
                        key={childNav.route}>
                        <div className='justify-between scan-item'>
                          <span>{childNav.name}</span>
                          <div className={` ${childNav.exception > 0 ? 'scan-details' : 'scan-details-none'}`}>
                            {childNav.exception > 0 && <div className='exception'>{childNav.exception}</div>}
                            <div className='flex'>
                              <span>{`(${childNav.qty})`}</span>
                              <span className='delete-scan'>
                                <Button
                                  type="link"
                                  disabled={shipping_document_details?.shipment_status_value === 'delivered' ||
                                    shipping_document_details?.shipment_status_value === 'approved'}
                                  style={{ padding: '3px' }}
                                  onClick={() => {
                                    deleteBatch(childNav.id);
                                  }}
                                  title={"Delete"}
                                >
                                  <DeleteIcon />
                                </Button>
                              </span>
                            </div>
                          </div>
                        </div>
                      </Menu.Item>
                    )
                  })}
                </Menu.SubMenu>
                <div className='divider' />
              </>
            ) : (
              <Menu.Item key={nav.route}>
                <div className='justify-between'>
                  <span>{nav.name}</span>
                  <span>{`(${nav.qty})`}</span>
                </div>
              </Menu.Item>
            )
          ))}
        </Menu>
      </div>
      <div className="nested-btn">
        <button
          title='New Scan'
          disabled={shipping_document_details?.shipment_status_value === 'delivered' ||
            shipping_document_details?.shipment_status_value === 'approved'}
          onClick={() => {
            dispatch(clearShippingBatchItems())
            setSelectedKey('');
            if (!rfIdAttachRequired) getNewScan();
            else {
              navigate(`shipment-document/details/${id}/rfid`);
              setRfidAttachModelVisible(true)
            };
          }}
        >
          <PlusOutlined />
        </button>
      </div>
      {rfidAttachModelVisible &&
        <RfidAttachModel
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          rfidAttachModelVisible={rfidAttachModelVisible}
          setRFIDAttachRequired={setRFIDAttachRequired}
          setRfidAttachModelVisible={setRfidAttachModelVisible}
        ></RfidAttachModel>}
      <RfidCorruptedModel
        rfidCorruptedModel={rfidCorruptedModel}
        setRfidCorruptedModel={setRfidCorruptedModel}
        rfidCorruptedData={rfidCorruptedData}
      ></RfidCorruptedModel>
    </div>
  )
}